import type { IOrthOV1ProcedureExaminationsProps } from './OrthOV1ProcedureExaminations';
import { CircleCountHeading } from '../../../elements/CircleCountHeading';
import { OrthOV1ProcedureSelectedExtraAdditionalExaminations } from './OrthOV1ProcedureSelectedExtraAdditionalExaminations';

export function OrthOV1ProcedureAdditionalExaminations(props: IOrthOV1ProcedureExaminationsProps) {
    return (
        <>
            <CircleCountHeading
                count="5"
                label="Aanvullend onderzoek"
            />
            <OrthOV1ProcedureSelectedExtraAdditionalExaminations {...props} />
        </>
    );
}
